import { IPagination } from 'interfaces/common';
import appService from 'services/common';

const getUserTasks = (pagination?: IPagination) => {
  return appService.get('/tasks', { params: pagination });
};

export { getUserTasks };
